module.exports = __webpack_public_path__ + "img/RA8T.474dba84.svg";